import { Control, Map, IControl } from 'mapbox-gl';
import { useLayoutEffect } from 'react';

export type CustomMapboxControlProps = {
  htmlString: string;
  className?: string;
  onCallback?: Function;
};

export class CustomMapboxControl {
  map: any;
  container: any;
  htmlString: string;
  className?: string;
  onCallback?: Function;

  constructor(props: CustomMapboxControlProps) {
    this.htmlString = props.htmlString;
    this.className = props.className;
    this.onCallback = props.onCallback;
  }

  onAdd(map: Map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className =
      this.className || 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this.container.innerHTML = this.htmlString;

    const buttons = this.container.querySelectorAll('button') as HTMLElement[];
    buttons.forEach((button: HTMLElement) => {
      button.addEventListener('click', () => {
        if (this.onCallback) {
          this.onCallback();
        }
      });
    });
    return this.container;
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
